import React from 'react';

export const Footer: React.FC = () => {
  return (
    <footer className="py-12 border-t border-slate-200 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 flex flex-col md:flex-row justify-between items-center gap-6">
        <p className="text-sm text-slate-500">
          © {new Date().getFullYear()} PERO Brief. Todos os direitos reservados.
        </p>
        <div className="flex gap-6">
          <span className="text-sm text-slate-400 cursor-not-allowed">Privacidade</span>
          <span className="text-sm text-slate-400 cursor-not-allowed">Termos</span>
        </div>
      </div>
    </footer>
  );
};